import React from 'react';
import { cnBem } from '@carnica/utils';
import { connect } from 'react-redux';
import { selectCommonDataPending, selectNavigationList, selectUserType } from "../../../store/selectors";
import { CardItem } from "./components/CardItem";
import styles from "./styles.pcss";
import { CardListSkeleton } from "./components/CardListSkeleton";
var cnCardList = cnBem('card-list', styles);
export var _CardList = function _CardList(_ref) {
  var navigationList = _ref.navigationList,
    pending = _ref.pending,
    userType = _ref.userType;
  if (pending || !navigationList) {
    return /*#__PURE__*/React.createElement(CardListSkeleton, {
      "data-t-id": "Container-CardList"
    });
  }
  return /*#__PURE__*/React.createElement("ul", {
    className: cnCardList(null, ['container'])
  }, Object.keys(navigationList).map(function (key) {
    return /*#__PURE__*/React.createElement(CardItem, {
      item: navigationList[key],
      userType: userType
    });
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    navigationList: selectNavigationList(state),
    pending: selectCommonDataPending(state),
    userType: selectUserType(state)
  };
};
export var CardList = connect(mapStateToProps)(_CardList);